import Application, { $, _ } from 'wgnet-awesomejs';
import mobile from 'wgnet-awesomejs/lib/mobile';
import 'wgnet-awesomejs/base/wg_ajax_extention';

import stringToUrl from 'source/lib/utils/string_to_url';
import { enableCsrfToken } from './lib/backbone_wg_ajax';
import './lib/components';

import base from './base';
import Settings from './lib/settings_model';

Application.on('mobile-browser-detected-onload', (options) => {
    const isDesktop = !options.detected || options.forceDesktop;

    if (!isDesktop && !options.useMobile) {
        Application.trigger('enable-mobile-styles');
    }
    if (options.useTouchDevice) {
        window.document.body.classList.add('page__touch');
    }
});

mobile();
base();

const isSameOrigin = function isSameOrigin(url) {
    if (!url) {
        return false;
    }
    const parseUrl = stringToUrl(url);
    const sitePath = Settings.get('App.SitePath');

    if (!_.isUndefined(parseUrl.hostname) && parseUrl.hostname !== window.location.hostname) {
        return false;
    }

    if (parseUrl.pathname === '') {
        return true;
    }

    const sitePathIntex = parseUrl.pathname.indexOf(sitePath);

    if (sitePathIntex === 0) {
        return true;
    }

    if (sitePathIntex === -1 && parseUrl.pathname.charAt(0) !== '/') {
        return true;
    }

    return false;
};
const HtmlForms = {
    create(method, url, params, target, sendCsrfToken = true) {
        const $form = $('<form>');

        $form.attr('method', method).attr('action', url);

        if (target) {
            $form.attr('target', target);
        }

        if (params) {
            $.each(params, (key, value) => $('<input type="hidden">')
                .attr('name', key)
                .attr('value', value)
                .appendTo($form));
        }
        const upperCasedMethod = typeof method === 'string' ? method.toUpperCase() : method;
        if (sendCsrfToken && upperCasedMethod === 'POST' && isSameOrigin(url)) {
            $('<input type="hidden">')
                .attr('name', 'csrfmiddlewaretoken')
                .attr('value', enableCsrfToken('wgni'))
                .appendTo($form);
        }

        $form.appendTo('body');
        return $form;
    },
    send(method, url, params, target, sendCsrfToken) {
        const $form = this.create(method, url, params, target, sendCsrfToken);

        $form.submit();
    },
    sendGet(url, params, target) {
        return this.send('GET', url, params, target);
    },
    sendPost(url, params, target, sendCsrfToken) {
        return this.send('POST', url, params, target, sendCsrfToken);
    },
};

Application.on('menu-logout', (event, data) => {
    const params = { return_to: _.extract(data, 'returnTo') };
    const logoutUrl = Settings.get('Authentication.LogoutUrl');
    const method = Settings.get('Authentication.LogoutMethod');

    if (method === 'get') {
        HtmlForms.sendGet(logoutUrl, params);
    } else {
        HtmlForms.sendPost(logoutUrl, params);
    }

    event.preventDefault();
});
